export default [
  {
    path: "/main/atendimentos/signature",
    meta: {
      tag: "signature",
      name: "Signature",
      breadcrumb: "Signature",
      menu: "settings",
    },
    component: () =>
      import(
        /* webpackChunkName: "signature" */ "@/views/main/settings/atendimentos/signature/Signature.vue"
      ),
  },
];
